import { render, staticRenderFns } from "./Veld.vue?vue&type=template&id=bbad1ec0"
import script from "./Veld.vue?vue&type=script&lang=js"
export * from "./Veld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports